
import { NavigationTranslationType } from "../../features/navigation.types";

export const navigation: NavigationTranslationType = {
  navigation: {
    dashboard: "لوحة التحكم",
    profile: "الملف الشخصي",
    signOut: "تسجيل الخروج",
    upgradeRequired: "مطلوب الترقية",
    basicSubscriptionRequired: "مطلوب اشتراك أساسي",
    premiumSubscriptionRequired: "مطلوب اشتراك مميز",
  }
};
